import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';

import { createAppModal } from 'utils/modal';

/**
 * A component that displays a non-dismissible modal when the WebSocket
 * connection has been unhealthy for an extended period, prompting the agent to
 * reload the page.
 */
export const WebSocketHealthCheckModal = createAppModal(
  { type: 'app:webSocketHealthCheck' },
  ({ isOpen }): JSX.Element => {
    const handleConfirm = () => {
      window.location.reload();
    };

    return (
      <Modal isOpen={isOpen} onClose={() => undefined} allowEscClose={false}>
        <ModalHead title="Connection lost" />

        <ModalBody>
          The connection has been lost. Please reload the page to reconnect.
        </ModalBody>

        <ModalFoot confirmName="Reload" confirmOnClick={handleConfirm} />
      </Modal>
    );
  },
);
